import request from '@/utils/request'

export const getServiceTypes = (industry: any) =>
  request({
    url: 'services_industries.types?service_industry_id=' + industry.id + '&per_page=100&page=1',
    method: 'get'
  })

export const deleteServiceType = (data: any) =>
request({
  url: '/service-types',
  method: 'delete',
  data
})
